document.addEventListener('turbolinks:load', () => {
	$('body').on('click', '.message .button.is-close', (e) => {
		e.target.closest('.message').classList.add('invis')
	})
})
